module.exports = __webpack_public_path__ + "static/media/sim_background_blur.021d3b1a.png";